import React from "react"
import styled from "styled-components"
import moment from "moment"
import { Container } from "../global"

const Footer = () => (
  <FooterWrapper id="footer">
    <FooterColumnContainer>
      <FooterColumn>
        <span>Resources</span>
        <ul>
          <li>
            <a href="https://discord.gg/wjBskqk" target="blank">
              Discord
            </a>
          </li>
          <li>
            <a href="https://huevosrevueltos.com.mx/" target="blank">
              Blog
            </a>
          </li>
        </ul>
      </FooterColumn>
      <FooterColumn>
        <span>Documents</span>
        <ul>
          <li>
            <a href="/termsconditions" target="blank">
              Terms & conditions
            </a>
          </li>
          <li>
            <a href="/privacy" target="blank">
              Privacy
            </a>
          </li>
        </ul>
      </FooterColumn>
      <FooterColumn>
        <span>Social</span>
        <ul>
          <li>
            <a
              href="https://www.linkedin.com/in/eduardo-avila-mancilla-b8ab4a164/"
              target="blank"
            >
              LinkedIn
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/el_eduard/" target="blank">
              Instagram
            </a>
          </li>
        </ul>
      </FooterColumn>
    </FooterColumnContainer>
    <Copy>
      Copyright © {moment().format("YYYY")}· Eduardo Avila ·{" "}
      <a href="mailto:donotreply@ecolote.com">Contact mail</a> · {" "}
      <a href="https://eduaravila.com/">Web</a>
    </Copy>
  </FooterWrapper>
)

const FooterWrapper = styled.footer`
  background-color: white;
  margin: 80px 0 0;
  padding: 0 0 80px;
`

const Copy = styled.footer`
  margin-top: 50px;
  font-family: ${props => props.theme.font.normal};
  font-size: 15px;
  text-align: center;
`

const Logo = styled.div`
  font-family: ${props => props.theme.font.extrabold};
  ${props => props.theme.font_size.regular};
  color: ${props => props.theme.color.black.regular};
  text-decoration: none;
  letter-spacing: 1px;
  margin: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 9;
  text-decoration: none;
  outline: 0px;
`

const BrandContainer = styled(Container)`
  position: relative;
  padding-top: 48px;
  display: flex;
  align-items: flex-end;

  @media (max-width: ${props => props.theme.screen.sm}) {
  }
`
const FooterColumnContainer = styled(Container)`
  display: flex;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 32px;
  justify-content: space-evenly;
  @media (max-width: ${props => props.theme.screen.sm}) {
    grid-template-columns: 1fr 1fr;
    grid-gap: 32px;
  }
`
const FooterColumn = styled.div`
  span {
    font-size: 16px;
    font-family: ${props => props.theme.font.bold};
    color: ${props => props.theme.color.primary};
  }
  ul {
    list-style: none;
    margin: 16px 0;
    padding: 0;
    color: ${props => props.theme.color.black.regular};
    li {
      margin-bottom: 12px;
      font-family: ${props => props.theme.font.normal};
      font-size: 15px;
    }
  }
`

export default Footer
